<template>
    <div class="modal fade" id="demanda_delete_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Deletar</b>
                        </h5>
                        <!-- <button type="button" class="close">
                            <span aria-hidden="true">×</span>
                        </button> -->
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">
                            Deseja realmente DELETAR a <b>DEMANDA</b>?
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-danger"
                            @click.prevent.stop="deleteDemanda">
                            Deletar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';

    export default {

    	components: {
            Dot
        },


    	data(){
            return {
                currentPagePagination: null,

            	isLoading: false,

                //ARRAYS
            	errors: [],

                //OBJECTS
                delete_demanda: {}
            }
        },

        mounted(){
        	this.registryEventOpenModalDeleteDemanda();
        },

        methods: {
            registryEventOpenModalDeleteDemanda(){
                eventBus.$on('eventOpenModalDeleteDemanda', (deleteDemanda, currentPage) => {
                	this.errors = [];
                    this.delete_demanda = Object.assign({}, deleteDemanda);
                    this.currentPagePagination = currentPage;
                    $("#demanda_delete_modal").modal("show");
                });
            },

            emitEventGetDemandas(){
                eventBus.$emit('eventGetDemandas', this.currentPagePagination);
            },

            deleteDemanda()
            {
                this.isLoading = true;
                axios.delete(
                    '/demanda/' + this.delete_demanda.id
                )
                .then(response => {
                    this.isLoading = false;
                    $("#demanda_delete_modal").modal("hide");
                    toastr.success(response.data.message);
                    this.emitEventGetDemandas();
                })
                .catch(error => {
                    this.isLoading = false;
                    let erroObject = error.response.data;
                    if(erroObject.message)
                    {
                        toastr.error(erroObject.message);
                    }
                });
            }

            
            
        }
    }
</script>